import { ITokenizedCardGetAllResponse } from '../../../../shared/api/gateway/types';
import { ITokenizedCard } from '../../models';
import { adaptResponseToTokenizedCard } from './adaptResponseToTokenizedCard';

export function adaptGetAllResponseToTokenizedCards(
	cards: ITokenizedCardGetAllResponse,
): ITokenizedCard[] {
	return cards.map(adaptResponseToTokenizedCard);
}
